function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MobileFooterCTA from '@domain-group/fe-co-allhomes-agent-mobile-cta';
import { AgentRecommendationsGraphQL } from '@domain-group/fe-co-allhomes-agent-recommendations';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { AgentEnquiryForm } from '@domain-group/fe-co-allhomes-enquiry-form';
import AllhomesListingCard, { AllhomesListingCardsTabs } from '@domain-group/fe-co-allhomes-listing-card';
import StickyFooter from '@domain-group/fe-co-allhomes-sticky-footer';
import AllhomesAgentModel from './components/agent-model';
import AllhomesAgentBody from './components/agent-body';
import AllhomesAgentFooter from './components/agent-footer';
import AgentArticles from './components/agent-articles';
import { agentProfileInteractionEvent } from './components/ga-helpers';
import { articleProps } from './common-props';
import useSendPageView from './wrappers/use-send-page-view';
import * as styles from './allhomes-agent-profile-page.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentProfilePage = props => {
  var _props$details, _props$details2;
  useSendPageView((_props$details = props.details) === null || _props$details === void 0 ? void 0 : _props$details.id, (_props$details2 = props.details) === null || _props$details2 === void 0 ? void 0 : _props$details2.name);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    emailEnquiryModalOpen = _useState2[0],
    setEmailEnquiryModalOpen = _useState2[1];
  var _props$media = props.media,
    smallTablet = _props$media.smallTablet,
    mobile = _props$media.mobile;
  var listingTabNames = {
    sales: 'Sale',
    rentals: 'Rental',
    sold: 'Sold',
    rented: 'Rented'
  };

  // GA event handlers
  var listingTabClickHandler = tab => {
    agentProfileInteractionEvent("Listings Tab - ".concat(listingTabNames[tab.id]));
  };
  var listingCardClickHandler = (listingId, tab) => {
    agentProfileInteractionEvent("Property Click - ".concat(listingTabNames[tab.id]));
  };
  var articlesLayout = () => {
    if (mobile) {
      return 'column';
    }
    if (smallTablet) {
      return 'two-row';
    }
    return 'row';
  };
  return ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.bodySection
  }, ___EmotionJSX(EventBoundary, {
    name: "agent"
  }, ___EmotionJSX(AllhomesAgentBody, {
    profile: props.details,
    maxPreviewHeight: props.maxPreviewHeight,
    onEmailClick: () => setEmailEnquiryModalOpen(true)
  }), props.articles.length > 0 && ___EmotionJSX(AgentArticles, {
    layout: articlesLayout(),
    articles: props.articles
  })), props.initialListings && ___EmotionJSX(AllhomesListingCardsTabs, {
    css: styles.listingCards,
    title: "Listings by ".concat(props.details.name),
    titleTagType: "h2",
    sourceId: props.details.id,
    sourceType: "agent",
    className: "allhomes-agent-profile__allhomes-listing-card-list",
    eventHandlers: {
      tabClicked: listingTabClickHandler,
      listingCardClicked: listingCardClickHandler,
      showAllClicked: props.onShowAll,
      showLessClicked: props.onShowLess
    },
    tabs: [{
      id: 'sales',
      label: 'For Sale',
      labelMobile: 'Sale',
      totalCount: props.initialListings.sales.total,
      initialSearchResult: props.initialListings.sales.listings,
      subTitle: "".concat(props.initialListings.sales.total, " ").concat(props.initialListings.sales.total > 1 ? 'properties' : 'property', " for sale"),
      duration: ''
    }, {
      id: 'rentals',
      label: 'For Rent',
      labelMobile: 'Rent',
      totalCount: props.initialListings.rentals.total,
      initialSearchResult: props.initialListings.rentals.listings,
      subTitle: "".concat(props.initialListings.rentals.total, " ").concat(props.initialListings.rentals.total > 1 ? 'properties' : 'property', " for rent"),
      duration: ''
    }, {
      id: 'sold',
      label: 'Sold',
      labelMobile: 'Sold',
      totalCount: props.initialListings.recentlySold.total,
      initialSearchResult: props.initialListings.recentlySold.listings,
      subTitle: "".concat(props.initialListings.recentlySold.total, " ").concat(props.initialListings.recentlySold.total > 1 ? 'properties' : 'property', " sold"),
      duration: "Last ".concat(props.listingVisibility.sale.duration, " ").concat(props.listingVisibility.sale.unit, "s")
    }, {
      id: 'rented',
      label: 'Rented',
      labelMobile: 'Rented',
      totalCount: props.initialListings.recentlyRented.total,
      initialSearchResult: props.initialListings.recentlyRented.listings,
      subTitle: "".concat(props.initialListings.recentlyRented.total, " ").concat(props.initialListings.recentlyRented.total > 1 ? 'properties' : 'property', " rented"),
      duration: "Last ".concat(props.listingVisibility.rent.duration, " ").concat(props.listingVisibility.rent.unit, "s")
    }]
  }), props.reviewProfile && ___EmotionJSX("div", {
    css: styles.recommendations
  }, ___EmotionJSX(AgentRecommendationsGraphQL, {
    reviewProfile: props.reviewProfile
  }))), ___EmotionJSX(EventBoundary, {
    name: "footer"
  }, ___EmotionJSX(AllhomesAgentFooter, {
    profile: props.details,
    geocoderEndpoint: props.geocoderEndpoint,
    googleMapsParams: props.googleMapsParams,
    onEmailClick: () => setEmailEnquiryModalOpen(true)
  })), emailEnquiryModalOpen && ___EmotionJSX(AgentEnquiryForm, {
    endpointUrl: props.enquiryEndpoint,
    logoUrl: props.details.agency.images.profilePhoto,
    formTitle: "Contact ".concat(props.details.name),
    clientId: props.details.id,
    clientType: "AGENT",
    closeCallback: () => setEmailEnquiryModalOpen(false)
  }), mobile && ___EmotionJSX(StickyFooter, null, ___EmotionJSX(MobileFooterCTA, {
    phone: props.details.phone,
    onEmailClick: () => setEmailEnquiryModalOpen(true)
  })));
};
AllhomesAgentProfilePage.propTypes = {
  details: PropTypes.shape(AllhomesAgentModel).isRequired,
  onShowAll: PropTypes.func.isRequired,
  onShowLess: PropTypes.func.isRequired,
  googleMapsParams: PropTypes.shape({
    key: PropTypes.string.isRequired
  }).isRequired,
  maxPreviewHeight: PropTypes.number,
  initialListings: PropTypes.shape({
    sales: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    }),
    rentals: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    }),
    recentlySold: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    }),
    recentlyRented: PropTypes.shape({
      listings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
      total: PropTypes.number
    })
  }),
  enquiryEndpoint: PropTypes.string,
  geocoderEndpoint: PropTypes.string,
  reviewProfile: PropTypes.shape({}),
  listingVisibility: PropTypes.shape({
    sale: PropTypes.shape({
      duration: PropTypes.string,
      unit: PropTypes.string
    }),
    rent: PropTypes.shape({
      duration: PropTypes.string,
      unit: PropTypes.string
    })
  }),
  media: PropTypes.shape({
    smallTablet: PropTypes.bool,
    mobile: PropTypes.bool
  }),
  articles: PropTypes.arrayOf(PropTypes.shape(articleProps))
};
AllhomesAgentProfilePage.defaultProps = {
  maxPreviewHeight: undefined,
  initialListings: undefined,
  reviewProfile: {},
  enquiryEndpoint: '',
  geocoderEndpoint: '',
  listingVisibility: {
    sale: {
      duration: '',
      unit: ''
    },
    rent: {
      duration: '',
      unit: ''
    }
  },
  media: {},
  articles: []
};
export default AllhomesAgentProfilePage;